export * from "./components/index"
export * from './components/widget/widget.component'
export * from './components/dashboard/dashboard.component'
export * from './directives/widget-handle.directive'



// WEBPACK FOOTER //
// ../src/index.ts